<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :meun="meunItem" :title="meunTitle" title2="捐助详情" title3="编辑捐助信息"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <h3 class="title">编辑捐助信息</h3>
            <div class="aLine"></div>
            <div class="tableInfo">
              <div class="input_div">
                <p>捐助时间</p>
                <el-date-picker class="input" v-model="info.journal_time" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
              </div>
              <div class="input_div">
                <p>捐助内容</p>
                <el-input class="input" v-model="info.content" placeholder="请输入"></el-input>
              </div>
              <div class="input_div">
                <p>捐助金额</p>
                <el-input class="input" type="number" onkeyup="value=value.replace(/^(\d*\.?\d{0,2}).*/,'$1')" v-model="info.money" placeholder="请输入"></el-input>
              </div>
              <div class="input_div">
                <p>捐助类型</p>
                <el-select class="input" v-model="info.type" placeholder="请选择" collapse-tags>
                  <el-option v-for="item in typeOptions" :key="item" :value="item" :label="item"></el-option>
                </el-select>
              </div>
              <div class="input_div">
                <p>备注</p>
                <el-input class="input" v-model="info.remark" placeholder="请输入"></el-input>
              </div>
            </div>
          </div>
          <!-- <div class="footSubmit">
            <el-button
              style="float: right; margin-right: 30px"
              size="small"
              type="primary"
              @click="saveEdit()"
              >提交</el-button
            >
            <el-button
              style="float: right; margin-right: 15px"
              size="small"
              @click="toCancel()"
              >取消</el-button
            >
          </div> -->
          <FootLayout v-on:saveEdit="saveEdit"></FootLayout>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from '@/utils/strUtils.js'
import * as Constant from '@/utils/constant.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import { URL_PATH } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayout'
import FootLayout from '@/components/layout/footLayout'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    FootLayout
  },
  data() {
    return {
      meunItem: null,
      meunTitle: '',
      urlPath: URL_PATH,
      info: {},
      typeOptions: ['捐赠', '赞助'] //捐助类型
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.infoId = this.$route.query.id
      this.meunItem.infoId = this.infoId
      this.getInfo()
    },
    // 获取详情
    getInfo() {
      if (this.infoId == null) return
      this.$api
        .getDonationInfo({
          token: localStorage.getItem('token'),
          id: this.infoId
        })
        .then(({ data }) => {
          this.info = data.Data
        })
        .catch(({ error }) => {})
    },
    // 新增
    addInfo: function (form) {
      this.$api
        .updateAisJournal(form)
        .then(({ data }) => {
          this.$router.back(-1)
        })
        .catch(({ error }) => {})
    },
    // 编辑
    updateInfo: function (form) {
      // form.append("id", this.info.id);
      this.$api
        .updateAisJournal({
          id: this.info.id,
          token: localStorage.getItem('token'),
          journal_time: this.info.journal_time,
          content: this.info.content,
          money: this.info.money,
          remark: this.info.remark,
          type: this.info.type
        })
        .then(({ data }) => {
          this.$router.back(-1)
        })
        .catch(({ error }) => {})
    },
    // // 编辑
    // updateInfo: function (form) {
    //   form.append("id", this.info.id);
    //   this.$api
    //     .updateAisJournal(form)
    //     .then(({ data }) => {
    //       this.$router.back(-1);
    //     })
    //     .catch(({ error }) => {});
    // },
    // 保存
    saveEdit() {
      if (
        StrUtils.isEmpty(this.info.journal_time) ||
        StrUtils.isEmpty(this.info.content) ||
        // StrUtils.isEmpty(this.info.money) ||
        // StrUtils.isEmpty(this.info.remark) ||
        StrUtils.isEmpty(this.info.type)
      ) {
        this.$message.error('请先完善数据')
        return
      }
      var form = new FormData()
      form.append('token', localStorage.getItem('token'))
      form.append('journal_time', this.info.journal_time)
      form.append('content', this.info.content)
      form.append('money', this.info.money)
      form.append('remark', this.info.remark)
      form.append('type', this.info.type)
      if (this.infoId) {
        this.updateInfo(form)
      } else {
        this.addInfo(form)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
  height: 75vh;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-top: 24px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.operateText {
  font-size: 14px;
}

.input_div {
  width: 290px;
  margin-right: 120px;
  margin-bottom: 32px;
  float: left;
}
.input_div .input {
  width: 100%;
}
.input_div p {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
  margin-bottom: 8px;
}
</style>

 <style lang="less">
/* element样式重置 start */
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type='number'] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
/* 去掉input尾部上下小箭头 end */
</style>


// WEBPACK FOOTER //
// src/pages/dataMgr/journalDetailsManualAdd.vue